import { render, staticRenderFns } from "./BlindBoxTpl.vue?vue&type=template&id=6fee9c3a&scoped=true&"
import script from "./BlindBoxTpl.vue?vue&type=script&lang=js&"
export * from "./BlindBoxTpl.vue?vue&type=script&lang=js&"
import style0 from "./BlindBoxTpl.vue?vue&type=style&index=0&id=6fee9c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee9c3a",
  null
  
)

export default component.exports